(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b12-landing-page-concepts"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.b12xReady === 'true') return;
      root.dataset.b12xReady = 'true';

      const packs = [...root.querySelectorAll('[data-b12x-pack]')];
      const crossSellButtons = [...root.querySelectorAll('[data-b12x-cross-sell]')];
      const form = root.querySelector('[data-b12x-form]');
      const submit = root.querySelector('[data-b12x-submit]');
      const quantityInput = root.querySelector('[data-b12x-quantity]');
      const selectedSummary = root.querySelector('[data-b12x-selected-summary]');
      const selectedTotal = root.querySelector('[data-b12x-selected-total]');
      const stickySummary = root.querySelector('[data-b12x-sticky-summary]');
      const stickyTotal = root.querySelector('[data-b12x-sticky-total]');
      const stickyButton = root.querySelector('[data-b12x-sticky-button]');
      const status = root.querySelector('[data-b12x-status]');
      const hero = root.querySelector('[data-b12x-hero]');
      const offer = root.querySelector('[data-b12x-offer]');
      const unitPrice = Number(root.dataset.unitPrice || 0);
      const currency = root.dataset.currency || 'RON';
      let selectedPack = packs.find((pack) => pack.classList.contains('is-selected')) || packs[0];
      let heroVisible = true;
      let offerVisible = false;

      const money = (cents) => new Intl.NumberFormat('ro-RO', {
        style: 'currency',
        currency,
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(cents / 100);

      const getPackMath = (pack) => {
        const quantity = Number(pack?.dataset.quantity || 1);
        const discount = Number(pack?.dataset.discount || 0);
        const total = Math.round(unitPrice * quantity * (100 - discount) / 100);
        return { quantity, discount, total, perUnit: Math.round(total / quantity) };
      };

      const getCrossSellTotal = () => crossSellButtons
        .filter((button) => button.getAttribute('aria-pressed') === 'true')
        .reduce((sum, button) => sum + Number(button.dataset.unitPrice || 0), 0);

      const refreshPackPrices = () => {
        packs.forEach((pack) => {
          const values = getPackMath(pack);
          const total = pack.querySelector('[data-b12x-pack-total]');
          const perUnit = pack.querySelector('[data-b12x-pack-unit]');
          if (total) total.textContent = money(values.total);
          if (perUnit) perUnit.textContent = `${money(values.perUnit)} / cutie`;
        });
      };

      const refreshSelection = () => {
        if (!selectedPack) return;
        const values = getPackMath(selectedPack);
        const title = selectedPack.querySelector('strong')?.textContent?.trim() || '';
        const totalText = money(values.total + getCrossSellTotal());
        if (quantityInput) quantityInput.value = String(values.quantity);
        if (selectedSummary) selectedSummary.textContent = title;
        if (selectedTotal) selectedTotal.textContent = totalText;
        if (stickySummary) stickySummary.textContent = title;
        if (stickyTotal) stickyTotal.textContent = totalText;
        if (submit && !submit.disabled) {
          const label = values.quantity === 1
            ? root.dataset.addOneLabel
            : root.dataset.addManyLabel.replace('[quantity]', String(values.quantity));
          submit.textContent = `${label} • ${totalText}`;
        }
      };

      packs.forEach((pack) => {
        pack.addEventListener('click', () => {
          packs.forEach((item) => {
            const selected = item === pack;
            item.classList.toggle('is-selected', selected);
            item.setAttribute('aria-pressed', String(selected));
          });
          selectedPack = pack;
          refreshSelection();
          if (status) status.textContent = `${root.dataset.selectedLabel}: ${pack.querySelector('strong')?.textContent?.trim() || ''}.`;
        });
      });

      crossSellButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const selected = button.getAttribute('aria-pressed') !== 'true';
          button.setAttribute('aria-pressed', String(selected));
          refreshSelection();
          const count = crossSellButtons.filter((item) => item.getAttribute('aria-pressed') === 'true').length;
          if (status) status.textContent = count ? root.dataset.crossSellSelectedLabel.replace('[count]', String(count)) : '';
        });
      });

      const updateSticky = () => root.classList.toggle('is-sticky-visible', !heroVisible && !offerVisible);
      let heroObserver;
      let offerObserver;

      if ('IntersectionObserver' in window && hero && offer) {
        heroObserver = new IntersectionObserver((entries) => {
          heroVisible = entries[0]?.isIntersecting ?? false;
          updateSticky();
        }, { threshold: .08 });
        offerObserver = new IntersectionObserver((entries) => {
          offerVisible = entries[0]?.isIntersecting ?? false;
          updateSticky();
        }, { threshold: .08 });
        heroObserver.observe(hero);
        offerObserver.observe(offer);
      }

      stickyButton?.addEventListener('click', () => form?.requestSubmit());

      form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!submit || submit.disabled || !selectedPack) return;
        const values = getPackMath(selectedPack);
        const originalText = submit.textContent;
        submit.disabled = true;
        submit.textContent = root.dataset.addingLabel;
        if (status) status.textContent = '';

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{
                id: Number(root.dataset.variantId),
                quantity: values.quantity,
                properties: { _landing_page: `b12-${root.dataset.concept}` }
              }, ...crossSellButtons
                .filter((button) => button.getAttribute('aria-pressed') === 'true')
                .map((button) => ({
                  id: Number(button.dataset.variantId),
                  quantity: 1,
                  properties: { _landing_page: `b12-${root.dataset.concept}-cross-sell` }
                }))]
            })
          });
          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || payload.message || root.dataset.errorLabel);
          window.location.assign(root.dataset.checkoutUrl);
        } catch (error) {
          if (status) status.textContent = error.message || root.dataset.errorLabel;
          submit.disabled = false;
          submit.textContent = originalText;
        }
      });

      refreshPackPrices();
      refreshSelection();
      root.b12xCleanup = () => {
        heroObserver?.disconnect();
        offerObserver?.disconnect();
      };
    };

    const initAll = (scope = document) => scope.querySelectorAll('[data-b12x]').forEach(init);
    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-b12x]').forEach((root) => root.b12xCleanup?.()));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b12-landing-page-static-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const money = (cents, currency) => new Intl.NumberFormat('ro-RO', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100);

    const init = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const unitPrice = Number(root.dataset.unitPrice || 0);
      const currency = root.dataset.currency || 'RON';
      const freeShippingThreshold = Number(root.dataset.freeShippingThreshold || 15000);
      const form = root.querySelector('[data-b12v2-form]');
      const quantityInput = root.querySelector('[data-b12v2-quantity]');
      const packs = Array.from(root.querySelectorAll('[data-b12v2-pack]'));
      const actionButtons = Array.from(root.querySelectorAll('[data-b12v2-action]'));
      const submitButton = root.querySelector('[data-b12v2-submit]');
      const crossSellButtons = Array.from(root.querySelectorAll('[data-b12v2-cross-sell]'));
      const status = root.querySelector('[data-b12v2-status]');
      const hero = root.querySelector('[data-b12v2-hero]');
      const offer = root.querySelector('[data-b12v2-offer]');
      const selectedSummary = root.querySelector('[data-b12v2-selected-summary]');
      const selectedTotal = root.querySelector('[data-b12v2-selected-total]');
      const finalSummary = root.querySelector('[data-b12v2-final-summary]');
      const finalTotal = root.querySelector('[data-b12v2-final-total]');
      const stickySummary = root.querySelector('[data-b12v2-sticky-summary]');
      const stickyTotal = root.querySelector('[data-b12v2-sticky-total]');
      const shippingMessage = root.querySelector('[data-b12v2-shipping-message]');
      const whyDialog = root.querySelector('[data-b12v2-why-dialog]');
      const whyOpeners = Array.from(root.querySelectorAll('[data-b12v2-why-open]'));
      const whyCloser = root.querySelector('[data-b12v2-why-close]');
      const whyCta = root.querySelector('[data-b12v2-why-cta]');
      let selectedPack = packs[0];
      let heroVisible = true;
      let offerVisible = false;

      const selectedExtras = () => crossSellButtons
        .filter((button) => button.getAttribute('aria-pressed') === 'true')
        .reduce((total, button) => total + Number(button.dataset.unitPrice || 0), 0);

      const packValues = (pack) => {
        const quantity = Number(pack?.dataset.quantity || 1);
        const discount = Number(pack?.dataset.discount || 0);
        const originalTotal = unitPrice * quantity;
        const total = Math.round(originalTotal * (1 - discount / 100));
        return { quantity, discount, originalTotal, total, unit: Math.round(total / quantity) };
      };

      const selectedTitle = () => selectedPack?.querySelector('strong')?.textContent?.trim() || '';

      const refreshPackPrices = () => {
        packs.forEach((pack) => {
          const values = packValues(pack);
          const totalNode = pack.querySelector('[data-b12v2-pack-total]');
          const unitNode = pack.querySelector('[data-b12v2-pack-unit]');
          const compareNode = pack.querySelector('[data-b12v2-pack-compare]');
          if (totalNode) totalNode.textContent = money(values.total, currency);
          if (unitNode) unitNode.textContent = `${money(values.unit, currency)} ${root.dataset.packUnitLabel}`;
          if (compareNode) {
            compareNode.textContent = money(values.originalTotal, currency);
            compareNode.hidden = values.discount === 0;
          }
        });
      };

      const refresh = () => {
        const values = packValues(selectedPack);
        const total = values.total + selectedExtras();
        const title = selectedTitle();
        const totalText = money(total, currency);
        const longLabel = values.quantity === 1
          ? root.dataset.addOneLabel
          : root.dataset.addManyLabel.replace('[quantity]', String(values.quantity));

        if (quantityInput) quantityInput.value = String(values.quantity);
        if (selectedSummary) selectedSummary.textContent = title;
        if (selectedTotal) selectedTotal.textContent = totalText;
        if (finalSummary) finalSummary.textContent = title;
        if (finalTotal) finalTotal.textContent = totalText;
        if (stickySummary) stickySummary.textContent = title;
        if (stickyTotal) stickyTotal.textContent = totalText;

        actionButtons.forEach((button) => {
          if (button.dataset.b12v2ShortAction !== undefined) return;
          button.textContent = `${longLabel} · ${totalText}`;
        });

        if (shippingMessage) {
          const remaining = Math.max(0, freeShippingThreshold - total);
          shippingMessage.textContent = remaining > 0
            ? root.dataset.shippingProgressLabel.replace('[amount]', money(remaining, currency))
            : root.dataset.shippingUnlockedLabel;
        }
      };

      packs.forEach((pack) => {
        pack.addEventListener('click', () => {
          selectedPack = pack;
          packs.forEach((item) => {
            const active = item === pack;
            item.classList.toggle('is-selected', active);
            item.setAttribute('aria-pressed', String(active));
          });
          refresh();
        });
      });

      crossSellButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const active = button.getAttribute('aria-pressed') !== 'true';
          button.setAttribute('aria-pressed', String(active));
          const count = crossSellButtons.filter((item) => item.getAttribute('aria-pressed') === 'true').length;
          refresh();
          if (status) status.textContent = count > 0
            ? root.dataset.crossSellSelectedLabel.replace('[count]', String(count))
            : '';
        });
      });

      whyOpeners.forEach((button) => {
        button.addEventListener('click', () => {
          if (!whyDialog) return;
          if (typeof whyDialog.showModal === 'function') whyDialog.showModal();
          else whyDialog.setAttribute('open', '');
        });
      });

      whyCloser?.addEventListener('click', () => whyDialog?.close());
      whyCta?.addEventListener('click', () => whyDialog?.close());
      whyDialog?.addEventListener('click', (event) => {
        if (event.target === whyDialog) whyDialog.close();
      });

      const updateSticky = () => {
        root.classList.toggle('is-sticky-visible', !heroVisible && !offerVisible);
      };

      if ('IntersectionObserver' in window) {
        const heroObserver = new IntersectionObserver((entries) => {
          heroVisible = entries[0]?.isIntersecting ?? false;
          updateSticky();
        }, { threshold: .05 });
        const offerObserver = new IntersectionObserver((entries) => {
          offerVisible = entries[0]?.isIntersecting ?? false;
          updateSticky();
        }, { threshold: .08 });
        if (hero) heroObserver.observe(hero);
        if (offer) offerObserver.observe(offer);
        root.b12v2Cleanup = () => {
          heroObserver.disconnect();
          offerObserver.disconnect();
        };
      }

      form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!submitButton || submitButton.disabled) return;

        const values = packValues(selectedPack);
        const originalLabels = actionButtons.map((button) => button.textContent);
        actionButtons.forEach((button) => {
          button.disabled = true;
          button.textContent = root.dataset.addingLabel;
        });
        if (status) status.textContent = '';

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: Number(root.dataset.variantId),
                quantity: values.quantity,
                properties: { _landing_page: 'b12-static-v2' }
              }, ...crossSellButtons
                .filter((button) => button.getAttribute('aria-pressed') === 'true')
                .map((button) => ({
                  id: Number(button.dataset.variantId),
                  quantity: 1,
                  properties: { _landing_page: 'b12-static-v2-cross-sell' }
                }))]
            })
          });

          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || payload.message || root.dataset.errorLabel);
          window.location.assign(root.dataset.checkoutUrl);
        } catch (error) {
          actionButtons.forEach((button, index) => {
            button.disabled = false;
            button.textContent = originalLabels[index];
          });
          if (status) status.textContent = error.message || root.dataset.errorLabel;
        }
      });

      refreshPackPrices();
      refresh();
    };

    const initAll = (scope = document) => scope.querySelectorAll('[data-b12v2]').forEach(init);
    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-b12v2]').forEach((root) => root.b12v2Cleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b12-landing-page-static"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selectors = {
      root: '[data-b12-landing]',
      pack: '[data-b12-pack]',
      quantity: '[data-b12-quantity]',
      form: '[data-b12-form]',
      submit: '[data-b12-submit]',
      status: '[data-b12-status]',
      hero: '[data-b12-hero]',
      offer: '[data-b12-offer]',
      crossSell: '[data-b12-cross-sell]',
      stickyButton: '[data-b12-sticky-button]'
    };

    const formatMoney = (cents, currency) => new Intl.NumberFormat('ro-RO', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100);

    const init = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const unitPrice = Number(root.dataset.unitPrice || 0);
      const currency = root.dataset.currency || 'RON';
      const packs = Array.from(root.querySelectorAll(selectors.pack));
      const quantityInput = root.querySelector(selectors.quantity);
      const form = root.querySelector(selectors.form);
      const submit = root.querySelector(selectors.submit);
      const status = root.querySelector(selectors.status);
      const selectedSummary = root.querySelector('[data-b12-selected-summary]');
      const selectedTotal = root.querySelector('[data-b12-selected-total]');
      const stickySummary = root.querySelector('[data-b12-sticky-summary]');
      const stickyTotal = root.querySelector('[data-b12-sticky-total]');
      const stickyButton = root.querySelector(selectors.stickyButton);
      const offer = root.querySelector(selectors.offer);
      const hero = root.querySelector(selectors.hero);
      const crossSellButtons = Array.from(root.querySelectorAll(selectors.crossSell));
      let selectedPack = packs[0];
      let heroVisible = true;
      let offerVisible = false;
      let heroObserver;
      let offerObserver;

      const getSelectedCrossSellTotal = () => crossSellButtons
        .filter((button) => button.getAttribute('aria-pressed') === 'true')
        .reduce((total, button) => total + Number(button.dataset.unitPrice || 0), 0);

      const getPackMath = (pack) => {
        const quantity = Number(pack.dataset.quantity || 1);
        const discount = Number(pack.dataset.discount || 0);
        const total = Math.round(unitPrice * quantity * (1 - discount / 100));
        const unit = Math.round(total / quantity);
        return { quantity, discount, total, unit };
      };

      const refreshPackPrices = () => {
        packs.forEach((pack) => {
          const values = getPackMath(pack);
          const totalNode = pack.querySelector('[data-b12-pack-total]');
          const unitNode = pack.querySelector('[data-b12-pack-unit]');
          if (totalNode) totalNode.textContent = formatMoney(values.total, currency);
          if (unitNode) unitNode.textContent = `${formatMoney(values.unit, currency)} / cutie`;
        });
      };

      const selectPack = (pack) => {
        selectedPack = pack;
        const values = getPackMath(pack);
        packs.forEach((item) => {
          const active = item === pack;
          item.classList.toggle('is-selected', active);
          item.setAttribute('aria-pressed', String(active));
        });
        if (quantityInput) quantityInput.value = String(values.quantity);
        const title = pack.querySelector('.b12-pack__top strong')?.textContent?.trim() || '';
        const totalText = formatMoney(values.total + getSelectedCrossSellTotal(), currency);
        if (selectedSummary) selectedSummary.textContent = title;
        if (selectedTotal) selectedTotal.textContent = totalText;
        if (stickySummary) stickySummary.textContent = title;
        if (stickyTotal) stickyTotal.textContent = totalText;
        if (submit && !submit.disabled) {
          const label = values.quantity === 1
            ? root.dataset.addOneLabel
            : root.dataset.addManyLabel.replace('[quantity]', String(values.quantity));
          submit.textContent = `${label} • ${totalText}`;
        }
        if (status) status.textContent = `${root.dataset.selectedLabel}: ${title}.`;
      };

      packs.forEach((pack) => {
        pack.addEventListener('click', () => {
          selectPack(pack);
        });
      });

      crossSellButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const selected = button.getAttribute('aria-pressed') !== 'true';
          button.setAttribute('aria-pressed', String(selected));
          const count = crossSellButtons.filter((item) => item.getAttribute('aria-pressed') === 'true').length;
          selectPack(selectedPack);
          if (status && count > 0) {
            status.textContent = root.dataset.crossSellSelectedLabel.replace('[count]', String(count));
          } else if (status) {
            status.textContent = '';
          }
        });
      });

      refreshPackPrices();
      if (selectedPack) selectPack(selectedPack);

      const updateSticky = () => {
        root.classList.toggle('is-sticky-visible', !heroVisible && !offerVisible);
      };

      if ('IntersectionObserver' in window && hero && offer) {
        heroObserver = new IntersectionObserver((entries) => {
          heroVisible = entries[0]?.isIntersecting ?? false;
          updateSticky();
        }, { threshold: .08 });
        offerObserver = new IntersectionObserver((entries) => {
          offerVisible = entries[0]?.isIntersecting ?? false;
          updateSticky();
        }, { threshold: .12 });
        heroObserver.observe(hero);
        offerObserver.observe(offer);
      }

      root.b12StoryCleanup = () => {
        heroObserver?.disconnect();
        offerObserver?.disconnect();
      };

      stickyButton?.addEventListener('click', () => {
        offer?.scrollIntoView({ behavior: 'auto', block: 'start' });
      });

      form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!submit || submit.disabled) return;
        const values = getPackMath(selectedPack);
        submit.disabled = true;
        submit.dataset.originalText = submit.textContent;
        submit.textContent = root.dataset.addingLabel;
        if (status) status.textContent = '';

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: Number(root.dataset.variantId),
                quantity: values.quantity,
                properties: { _landing_page: 'b12' }
              }, ...crossSellButtons
                .filter((button) => button.getAttribute('aria-pressed') === 'true')
                .map((button) => ({
                  id: Number(button.dataset.variantId),
                  quantity: 1,
                  properties: { _landing_page: 'b12-cross-sell' }
                }))]
            })
          });

          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || payload.message || root.dataset.errorLabel);
          window.location.assign(root.dataset.checkoutUrl);
        } catch (error) {
          if (status) status.textContent = error.message || root.dataset.errorLabel;
          submit.disabled = false;
          submit.textContent = submit.dataset.originalText;
        }
      });
    };

    const initAll = (scope = document) => scope.querySelectorAll(selectors.root).forEach(init);
    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(selectors.root).forEach((root) => root.b12StoryCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b12-landing-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selectors = {
      root: '[data-b12-landing]',
      pack: '[data-b12-pack]',
      quantity: '[data-b12-quantity]',
      form: '[data-b12-form]',
      submit: '[data-b12-submit]',
      status: '[data-b12-status]',
      hero: '[data-b12-hero]',
      story: '[data-b12-scroll-story]',
      offer: '[data-b12-offer]',
      crossSell: '[data-b12-cross-sell]',
      stickyButton: '[data-b12-sticky-button]'
    };

    const formatMoney = (cents, currency) => new Intl.NumberFormat('ro-RO', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100);

    const init = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const unitPrice = Number(root.dataset.unitPrice || 0);
      const currency = root.dataset.currency || 'RON';
      const packs = Array.from(root.querySelectorAll(selectors.pack));
      const quantityInput = root.querySelector(selectors.quantity);
      const form = root.querySelector(selectors.form);
      const submit = root.querySelector(selectors.submit);
      const status = root.querySelector(selectors.status);
      const selectedSummary = root.querySelector('[data-b12-selected-summary]');
      const selectedTotal = root.querySelector('[data-b12-selected-total]');
      const stickySummary = root.querySelector('[data-b12-sticky-summary]');
      const stickyTotal = root.querySelector('[data-b12-sticky-total]');
      const stickyButton = root.querySelector(selectors.stickyButton);
      const offer = root.querySelector(selectors.offer);
      const hero = root.querySelector(selectors.hero);
      const story = root.querySelector(selectors.story);
      const crossSellButtons = Array.from(root.querySelectorAll(selectors.crossSell));
      const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      let selectedPack = packs[0];
      let heroVisible = true;
      let offerVisible = false;
      let heroObserver;
      let offerObserver;

      const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
      const smoothstep = (start, end, value) => {
        const progress = clamp((value - start) / Math.max(.0001, end - start));
        return progress * progress * (3 - 2 * progress);
      };
      const smootherstep = (start, end, value) => {
        const progress = clamp((value - start) / Math.max(.0001, end - start));
        return progress * progress * progress * (progress * (progress * 6 - 15) + 10);
      };
      const windowed = (value, enterStart, enterEnd, exitStart, exitEnd) => (
        smoothstep(enterStart, enterEnd, value) * (1 - smoothstep(exitStart, exitEnd, value))
      );

      const getSelectedCrossSellTotal = () => crossSellButtons
        .filter((button) => button.getAttribute('aria-pressed') === 'true')
        .reduce((total, button) => total + Number(button.dataset.unitPrice || 0), 0);

      const getPackMath = (pack) => {
        const quantity = Number(pack.dataset.quantity || 1);
        const discount = Number(pack.dataset.discount || 0);
        const total = Math.round(unitPrice * quantity * (1 - discount / 100));
        const unit = Math.round(total / quantity);
        return { quantity, discount, total, unit };
      };

      const refreshPackPrices = () => {
        packs.forEach((pack) => {
          const values = getPackMath(pack);
          const totalNode = pack.querySelector('[data-b12-pack-total]');
          const unitNode = pack.querySelector('[data-b12-pack-unit]');
          if (totalNode) totalNode.textContent = formatMoney(values.total, currency);
          if (unitNode) unitNode.textContent = `${formatMoney(values.unit, currency)} / cutie`;
        });
      };

      const selectPack = (pack) => {
        selectedPack = pack;
        const values = getPackMath(pack);
        packs.forEach((item) => {
          const active = item === pack;
          item.classList.toggle('is-selected', active);
          item.setAttribute('aria-pressed', String(active));
        });
        if (quantityInput) quantityInput.value = String(values.quantity);
        const title = pack.querySelector('.b12-pack__top strong')?.textContent?.trim() || '';
        const totalText = formatMoney(values.total + getSelectedCrossSellTotal(), currency);
        if (selectedSummary) selectedSummary.textContent = title;
        if (selectedTotal) selectedTotal.textContent = totalText;
        if (stickySummary) stickySummary.textContent = title;
        if (stickyTotal) stickyTotal.textContent = totalText;
        if (submit && !submit.disabled) {
          const label = values.quantity === 1
            ? root.dataset.addOneLabel
            : root.dataset.addManyLabel.replace('[quantity]', String(values.quantity));
          submit.textContent = `${label} • ${totalText}`;
        }
        if (status) status.textContent = `${root.dataset.selectedLabel}: ${title}.`;
      };

      packs.forEach((pack) => {
        pack.addEventListener('click', () => {
          selectPack(pack);
        });
      });

      crossSellButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const selected = button.getAttribute('aria-pressed') !== 'true';
          button.setAttribute('aria-pressed', String(selected));
          const count = crossSellButtons.filter((item) => item.getAttribute('aria-pressed') === 'true').length;
          selectPack(selectedPack);
          if (status && count > 0) {
            status.textContent = root.dataset.crossSellSelectedLabel.replace('[count]', String(count));
          } else if (status) {
            status.textContent = '';
          }
        });
      });

      refreshPackPrices();
      if (selectedPack) selectPack(selectedPack);

      const updateSticky = () => {
        root.classList.toggle('is-sticky-visible', !heroVisible && !offerVisible);
      };

      if ('IntersectionObserver' in window && hero && offer) {
        heroObserver = new IntersectionObserver((entries) => {
          heroVisible = entries[0]?.isIntersecting ?? false;
          updateSticky();
        }, { threshold: .08 });
        offerObserver = new IntersectionObserver((entries) => {
          offerVisible = entries[0]?.isIntersecting ?? false;
          updateSticky();
        }, { threshold: .12 });
        heroObserver.observe(hero);
        offerObserver.observe(offer);
      }

      root.b12StoryCleanup = () => {
        heroObserver?.disconnect();
        offerObserver?.disconnect();
      };

      if (story && !motionQuery.matches) {
        let frame = 0;
        let storyVisible = true;
        let storyTop = 0;
        let storyTravel = 1;
        let targetProgress = 0;
        let renderedProgress = 0;
        let progressVelocity = 0;
        let lastTimestamp = 0;
        let storyObserver;
        let storyResizeObserver;
        const storyImage = story.querySelector('.b12-story__image');

        const measureStory = () => {
          const rect = story.getBoundingClientRect();
          storyTop = rect.top + window.scrollY;
          storyTravel = Math.max(1, story.offsetHeight - window.innerHeight);
        };

        const readTargetProgress = () => clamp((window.scrollY - storyTop) / storyTravel);

        const applyStory = (progress) => {
          const movementProgress = smootherstep(.02, .82, progress);
          const introOpacity = 1 - smoothstep(.08, .2, progress);
          const doseOpacity = windowed(progress, .08, .15, .22, .29);
          const dailyOpacity = windowed(progress, .18, .25, .32, .39);
          const daysOpacity = windowed(progress, .28, .35, .42, .49);
          const formOpacity = windowed(progress, .4, .48, .58, .66);
          const formDraw = smoothstep(.42, .52, progress) * (1 - smoothstep(.6, .66, progress));
          const benefitOneOpacity = windowed(progress, .58, .64, .77, .84);
          const benefitTwoOpacity = windowed(progress, .62, .68, .79, .86);
          const benefitThreeOpacity = windowed(progress, .66, .72, .81, .88);
          const dockOpacity = smoothstep(.78, .91, progress);
          const cueOpacity = 1 - smoothstep(.03, .12, progress);
          const isDesktop = window.innerWidth >= 750;
          const sceneStart = isDesktop ? -2 : -2.5;
          const sceneEnd = isDesktop ? 3 : 6.2;
          const sceneY = sceneStart + (sceneEnd - sceneStart) * movementProgress;
          const sceneScale = 1.025 - .025 * movementProgress;

          story.style.setProperty('--b12-story-progress', progress.toFixed(4));
          story.style.setProperty('--b12-scene-y', `${sceneY.toFixed(3)}svh`);
          story.style.setProperty('--b12-scene-scale', sceneScale.toFixed(4));
          story.style.setProperty('--b12-intro-opacity', introOpacity.toFixed(4));
          story.style.setProperty('--b12-intro-y', `${(18 * smoothstep(.08, .2, progress)).toFixed(2)}px`);
          story.style.setProperty('--b12-dose-opacity', doseOpacity.toFixed(4));
          story.style.setProperty('--b12-dose-y', `${((1 - doseOpacity) * 12).toFixed(2)}px`);
          story.style.setProperty('--b12-daily-opacity', dailyOpacity.toFixed(4));
          story.style.setProperty('--b12-daily-y', `${((1 - dailyOpacity) * 12).toFixed(2)}px`);
          story.style.setProperty('--b12-days-opacity', daysOpacity.toFixed(4));
          story.style.setProperty('--b12-days-y', `${((1 - daysOpacity) * 12).toFixed(2)}px`);
          story.style.setProperty('--b12-form-opacity', formOpacity.toFixed(4));
          story.style.setProperty('--b12-form-draw', formDraw.toFixed(4));
          story.style.setProperty('--b12-form-y', `${((1 - formOpacity) * 14).toFixed(2)}px`);
          story.style.setProperty('--b12-benefit-1-opacity', benefitOneOpacity.toFixed(4));
          story.style.setProperty('--b12-benefit-2-opacity', benefitTwoOpacity.toFixed(4));
          story.style.setProperty('--b12-benefit-3-opacity', benefitThreeOpacity.toFixed(4));
          story.style.setProperty('--b12-benefit-1-y', `${((1 - benefitOneOpacity) * 12).toFixed(2)}px`);
          story.style.setProperty('--b12-benefit-2-y', `${((1 - benefitTwoOpacity) * 12).toFixed(2)}px`);
          story.style.setProperty('--b12-benefit-3-y', `${((1 - benefitThreeOpacity) * 12).toFixed(2)}px`);
          story.style.setProperty('--b12-dock-opacity', dockOpacity.toFixed(4));
          story.style.setProperty('--b12-dock-y', `${((1 - dockOpacity) * 34).toFixed(2)}px`);
          story.style.setProperty('--b12-cue-opacity', cueOpacity.toFixed(4));
          story.classList.toggle('is-b12-intro-hidden', introOpacity < .1);
          story.classList.toggle('is-b12-dock-active', dockOpacity > .56);
        };

        const animateStory = (timestamp) => {
          if (!storyVisible) {
            frame = 0;
            lastTimestamp = 0;
            return;
          }

          if (!lastTimestamp) lastTimestamp = timestamp;
          const deltaSeconds = Math.min(.032, Math.max(.001, (timestamp - lastTimestamp) / 1000));
          lastTimestamp = timestamp;
          const angularFrequency = window.innerWidth < 750 ? 13 : 11;
          const displacement = targetProgress - renderedProgress;
          const acceleration = angularFrequency * angularFrequency * displacement - 2 * angularFrequency * progressVelocity;
          progressVelocity += acceleration * deltaSeconds;
          renderedProgress = clamp(renderedProgress + progressVelocity * deltaSeconds);
          applyStory(renderedProgress);

          const settled = Math.abs(targetProgress - renderedProgress) < .0001 && Math.abs(progressVelocity) < .0001;
          if (settled) {
            renderedProgress = targetProgress;
            progressVelocity = 0;
            lastTimestamp = 0;
            applyStory(renderedProgress);
            frame = 0;
            return;
          }

          frame = window.requestAnimationFrame(animateStory);
        };

        const requestStoryFrame = (snap = false) => {
          targetProgress = readTargetProgress();
          if (snap) {
            renderedProgress = targetProgress;
            progressVelocity = 0;
            applyStory(renderedProgress);
            return;
          }
          if (!frame) frame = window.requestAnimationFrame(animateStory);
        };

        const handleStoryResize = () => {
          measureStory();
          requestStoryFrame(true);
        };

        const handleStoryScroll = () => {
          requestStoryFrame();
        };

        root.classList.add('is-b12-story-ready');
        measureStory();
        requestStoryFrame(true);
        window.addEventListener('scroll', handleStoryScroll, { passive: true });
        window.addEventListener('resize', handleStoryResize, { passive: true });
        window.visualViewport?.addEventListener('resize', handleStoryResize, { passive: true });
        storyImage?.addEventListener('load', handleStoryResize, { once: true });

        if ('IntersectionObserver' in window) {
          storyObserver = new IntersectionObserver((entries) => {
            storyVisible = entries[0]?.isIntersecting ?? false;
            story.classList.toggle('is-b12-motion-active', storyVisible);
            if (storyVisible) {
              measureStory();
              requestStoryFrame();
            }
          }, { rootMargin: '100% 0px' });
          storyObserver.observe(story);
        }

        if ('ResizeObserver' in window) {
          storyResizeObserver = new ResizeObserver(handleStoryResize);
          storyResizeObserver.observe(story);
        }

        root.b12StoryCleanup = () => {
          window.removeEventListener('scroll', handleStoryScroll);
          window.removeEventListener('resize', handleStoryResize);
          window.visualViewport?.removeEventListener('resize', handleStoryResize);
          storyImage?.removeEventListener('load', handleStoryResize);
          if (frame) window.cancelAnimationFrame(frame);
          storyObserver?.disconnect();
          storyResizeObserver?.disconnect();
          heroObserver?.disconnect();
          offerObserver?.disconnect();
        };
      }

      stickyButton?.addEventListener('click', () => {
        offer?.scrollIntoView({ behavior: motionQuery.matches ? 'auto' : 'smooth', block: 'start' });
      });

      form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!submit || submit.disabled) return;
        const values = getPackMath(selectedPack);
        submit.disabled = true;
        submit.dataset.originalText = submit.textContent;
        submit.textContent = root.dataset.addingLabel;
        if (status) status.textContent = '';

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: Number(root.dataset.variantId),
                quantity: values.quantity,
                properties: { _landing_page: 'b12' }
              }, ...crossSellButtons
                .filter((button) => button.getAttribute('aria-pressed') === 'true')
                .map((button) => ({
                  id: Number(button.dataset.variantId),
                  quantity: 1,
                  properties: { _landing_page: 'b12-cross-sell' }
                }))]
            })
          });

          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || payload.message || root.dataset.errorLabel);
          window.location.assign(root.dataset.checkoutUrl);
        } catch (error) {
          if (status) status.textContent = error.message || root.dataset.errorLabel;
          submit.disabled = false;
          submit.textContent = submit.dataset.originalText;
        }
      });
    };

    const initAll = (scope = document) => scope.querySelectorAll(selectors.root).forEach(init);
    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(selectors.root).forEach((root) => root.b12StoryCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["biome-product-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const money = (cents, currency) => new Intl.NumberFormat('ro-RO', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100);

    const init = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const unitPrice = Number(root.dataset.unitPrice || 0);
      const currency = root.dataset.currency || 'RON';
      const freeShippingThreshold = Number(root.dataset.freeShippingThreshold || 15000);
      const form = root.querySelector('[data-biome-lp-form]');
      const quantityInput = root.querySelector('[data-biome-lp-quantity]');
      const packs = Array.from(root.querySelectorAll('[data-biome-lp-pack]'));
      const actionButtons = Array.from(root.querySelectorAll('[data-biome-lp-action]'));
      const initialDisabledStates = actionButtons.map((button) => button.disabled);
      const submitButton = root.querySelector('[data-biome-lp-submit]');
      const crossSellButtons = Array.from(root.querySelectorAll('[data-biome-lp-cross-sell]'));
      const status = root.querySelector('[data-biome-lp-status]');
      const hero = root.querySelector('[data-biome-lp-hero]');
      const offer = root.querySelector('[data-biome-lp-offer]');
      const selectedSummary = root.querySelector('[data-biome-lp-selected-summary]');
      const selectedTotal = root.querySelector('[data-biome-lp-selected-total]');
      const finalSummary = root.querySelector('[data-biome-lp-final-summary]');
      const finalTotal = root.querySelector('[data-biome-lp-final-total]');
      const stickySummary = root.querySelector('[data-biome-lp-sticky-summary]');
      const stickyTotal = root.querySelector('[data-biome-lp-sticky-total]');
      const shippingMessage = root.querySelector('[data-biome-lp-shipping-message]');
      const whyDialog = root.querySelector('[data-biome-lp-why-dialog]');
      const whyOpeners = Array.from(root.querySelectorAll('[data-biome-lp-why-open]'));
      const whyCloser = root.querySelector('[data-biome-lp-why-close]');
      const whyCta = root.querySelector('[data-biome-lp-why-cta]');
      let selectedPack = packs[0];
      let heroVisible = true;
      let offerVisible = false;
      let existingCartSubtotal = 0;

      const selectedExtras = () => crossSellButtons
        .filter((button) => button.getAttribute('aria-pressed') === 'true')
        .reduce((total, button) => total + Number(button.dataset.unitPrice || 0), 0);

      const packValues = (pack) => {
        const quantity = Number(pack?.dataset.quantity || 1);
        const discount = Number(pack?.dataset.discount || 0);
        const originalTotal = unitPrice * quantity;
        const total = Math.round(originalTotal * (1 - discount / 100));
        return { quantity, discount, originalTotal, total, unit: Math.round(total / quantity) };
      };

      const selectedTitle = () => selectedPack?.querySelector('strong')?.textContent?.trim() || '';

      const refreshPackPrices = () => {
        packs.forEach((pack) => {
          const values = packValues(pack);
          const totalNode = pack.querySelector('[data-biome-lp-pack-total]');
          const unitNode = pack.querySelector('[data-biome-lp-pack-unit]');
          const compareNode = pack.querySelector('[data-biome-lp-pack-compare]');
          if (totalNode) totalNode.textContent = money(values.total, currency);
          if (unitNode) unitNode.textContent = `${money(values.unit, currency)} ${root.dataset.packUnitLabel}`;
          if (compareNode) {
            compareNode.textContent = money(values.originalTotal, currency);
            compareNode.hidden = values.discount === 0;
          }
        });
      };

      const refresh = () => {
        const values = packValues(selectedPack);
        const total = values.total + selectedExtras();
        const title = selectedTitle();
        const totalText = money(total, currency);
        const longLabel = values.quantity === 1
          ? root.dataset.addOneLabel
          : root.dataset.addManyLabel.replace('[quantity]', String(values.quantity));

        if (quantityInput) quantityInput.value = String(values.quantity);
        if (selectedSummary) selectedSummary.textContent = title;
        if (selectedTotal) selectedTotal.textContent = totalText;
        if (finalSummary) finalSummary.textContent = title;
        if (finalTotal) finalTotal.textContent = totalText;
        if (stickySummary) stickySummary.textContent = title;
        if (stickyTotal) stickyTotal.textContent = totalText;

        actionButtons.forEach((button) => {
          if (button.disabled || button.dataset.biomeLpShortAction !== undefined) return;
          button.textContent = `${longLabel} · ${totalText}`;
        });

        if (shippingMessage) {
          const remaining = Math.max(0, freeShippingThreshold - existingCartSubtotal - total);
          shippingMessage.textContent = remaining > 0
            ? root.dataset.shippingProgressLabel.replace('[amount]', money(remaining, currency))
            : root.dataset.shippingUnlockedLabel;
        }
      };

      packs.forEach((pack) => {
        pack.addEventListener('click', () => {
          selectedPack = pack;
          packs.forEach((item) => {
            const active = item === pack;
            item.classList.toggle('is-selected', active);
            item.setAttribute('aria-pressed', String(active));
          });
          refresh();
        });
      });

      crossSellButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const active = button.getAttribute('aria-pressed') !== 'true';
          button.setAttribute('aria-pressed', String(active));
          const count = crossSellButtons.filter((item) => item.getAttribute('aria-pressed') === 'true').length;
          refresh();
          if (status) status.textContent = count > 0
            ? root.dataset.crossSellSelectedLabel.replace('[count]', String(count))
            : '';
        });
      });

      whyOpeners.forEach((button) => {
        button.addEventListener('click', () => {
          if (!whyDialog) return;
          if (typeof whyDialog.showModal === 'function') whyDialog.showModal();
          else whyDialog.setAttribute('open', '');
        });
      });

      whyCloser?.addEventListener('click', () => whyDialog?.close());
      whyCta?.addEventListener('click', () => whyDialog?.close());
      whyDialog?.addEventListener('click', (event) => {
        if (event.target === whyDialog) whyDialog.close();
      });

      const updateSticky = () => {
        root.classList.toggle('is-sticky-visible', !heroVisible && !offerVisible);
      };

      if ('IntersectionObserver' in window) {
        const heroObserver = new IntersectionObserver((entries) => {
          heroVisible = entries[0]?.isIntersecting ?? false;
          updateSticky();
        }, { threshold: .05 });
        const offerObserver = new IntersectionObserver((entries) => {
          offerVisible = entries[0]?.isIntersecting ?? false;
          updateSticky();
        }, { threshold: .08 });
        if (hero) heroObserver.observe(hero);
        if (offer) offerObserver.observe(offer);
        root.biomeLpCleanup = () => {
          heroObserver.disconnect();
          offerObserver.disconnect();
        };
      }

      form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!submitButton || submitButton.disabled) return;

        const values = packValues(selectedPack);
        const originalLabels = actionButtons.map((button) => button.textContent);
        actionButtons.forEach((button, index) => {
          if (initialDisabledStates[index]) return;
          button.disabled = true;
          button.textContent = root.dataset.addingLabel;
        });
        if (status) status.textContent = '';

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: Number(root.dataset.variantId),
                quantity: values.quantity,
                properties: { _landing_page: `biome-lp-${root.dataset.pageCode}` }
              }, ...crossSellButtons
                .filter((button) => button.getAttribute('aria-pressed') === 'true')
                .map((button) => ({
                  id: Number(button.dataset.variantId),
                  quantity: 1,
                  properties: { _landing_page: `biome-lp-${root.dataset.pageCode}-cross-sell` }
                }))]
            })
          });

          const payload = await response.json();
          if (!response.ok) throw new Error(payload.description || payload.message || root.dataset.errorLabel);
          window.location.assign(root.dataset.checkoutUrl);
        } catch (error) {
          actionButtons.forEach((button, index) => {
            button.disabled = initialDisabledStates[index];
            button.textContent = originalLabels[index];
          });
          if (status) status.textContent = error.message || root.dataset.errorLabel;
        }
      });

      refreshPackPrices();
      refresh();
      fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } })
        .then((response) => response.ok ? response.json() : null)
        .then((cartData) => {
          if (!cartData) return;
          existingCartSubtotal = Number(cartData.total_price || 0);
          refresh();
        })
        .catch(() => {});
    };

    const initAll = (scope = document) => scope.querySelectorAll('[data-biome-lp]').forEach(init);
    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-biome-lp]').forEach((root) => root.biomeLpCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bm-header"]) return;
  try {
    
(() => {
  const selector = '.bm-product-menu--desktop[data-bm-product-menu]';
  document.addEventListener('click', event => {
    document.querySelectorAll(selector + '[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(selector + '[open]').forEach(menu => {
      menu.open = false;
      if (menu.contains(document.activeElement)) menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll(selector + '[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
